import CurrentSubscribs from './CurrentSubscribs';
import PaymentSection from './PaymentSection';
import AddressBilling from './AdressBilling';
import PaymentHistory from './PaymentHistory';

export default function SubscriptionsSection() {
  return (
    <div className="space-y-12">
      <CurrentSubscribs />
      <PaymentSection />
      <AddressBilling />
      <PaymentHistory />
    </div>
  );
}
